export default __webpack_public_path__ + "static/media/dowloadAppBG.99d574c7.png";